import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { featureCategories } from "../../../../../constants";

const OtherFeaturesForm = ({allMustHaveAmmenities}) => {
  const {
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useFormContext();

  const featureIds = watch("amenity.featureIds");

  useEffect(() => {
    if (featureIds === false) {
      setValue("amenity.featureIds", []);
    }

    // eslint-disable-next-line
  }, [featureIds, setValue]);

  return (
    <div className="main-container-form">
      <div className="row">
        {errors?.amenity?.facilitesIds && (
          <div className="error mt-2">
            {errors?.amenity?.facilitesIds.message}
          </div>
        )}
        {allMustHaveAmmenities
          ?.filter((feature) => feature.category === featureCategories.OTHERS)
          .map((feature) => (
            <div className="col-12 col-sm-6" key={feature.id}>
              <Form.Check
                className="mb-2"
                name="mainFeatures"
                type="checkbox"
                label={feature.title}
                value={feature.id}
                onChange={(e) => {
                  const updatedValues = e.target.checked
                    ? [
                        ...(getValues("amenity.featureIds") || []),
                        Number(e.target.value),
                      ]
                    : (getValues("amenity.featureIds") || []).filter(
                        (id) => id !== Number(e.target.value)
                      );

                  setValue("amenity.featureIds", updatedValues, {
                    shouldValidate: true,
                  });
                }}
                checked={(getValues("amenity.featureIds") || []).includes(
                  feature.id
                )}
              />
            </div>
          ))}
      </div>
    </div>
  );
};


const mapStateToProps = (state) => ({
  allMustHaveAmmenities: state.homeReducer.allMustHaveAmmenities,
});

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(OtherFeaturesForm)
